import React, { Component } from 'react';
//import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
//import PaypalExpressBtn from 'react-paypal-express-checkout';
import SimpleReactValidator from 'simple-react-validator';

//import Breadcrumb from '../common/breadcrumb';
import { removeFromWishlist } from '../../actions';
import { getCartTotal } from '../../services';
import Select from 'react-select';
import AuthService from '../services/auth.service';
import ApiService from '../services/api.service';
import Swal from 'sweetalert2';
//import Modal from 'react-responsive-modal';
import Form from 'react-validation/build/form';
import Input from 'react-validation/build/input';
import CheckButton from 'react-validation/build/button';
import Collapsible from 'react-collapsible';
import Moment from 'moment';
import { calculateTotal } from '../../libs/sum';
import COUNTRY_CODES from '../common/countryCodes';

const LIMA = { lat: -12.0464, lng: -77.0428 };

const required = (value) => {
  if (!value) {
    return (
      <div className="alert alert-danger ver-alert" role="alert">
        Este campo es obligatorio!
      </div>
    );
  }
};

class VerProfile extends Component {
  constructor(props) {
    super(props);
    this.handleAddAddress = this.handleAddAddress.bind(this);
    this.handleUpdateAddress = this.handleUpdateAddress.bind(this);
    this.handleUpdateUser = this.handleUpdateUser.bind(this);
    this.handleUpdatePassword = this.handleUpdatePassword.bind(this);
    //this.handleRegister = this.handleRegister.bind(this);
    this.onChangeAddress = this.onChangeAddress.bind(this);
    //this.onChangeUbigeo = this.onChangeUbigeo.bind(this);
    this.onChangeNumber = this.onChangeNumber.bind(this);
    this.onChangeInterior = this.onChangeInterior.bind(this);
    this.onChangeUrl = this.onChangeUrl.bind(this);
    this.onChangeReference = this.onChangeReference.bind(this);
    this.onchangeName = this.onchangeName.bind(this);
    this.onchangeLastName = this.onchangeLastName.bind(this);
    this.onchangeEmail = this.onchangeEmail.bind(this);
    this.onChangeCellphone = this.onChangeCellphone.bind(this);
    this.onChangeNroDoc = this.onChangeNroDoc.bind(this);
    this.onChangePassword = this.onChangePassword.bind(this);
    this.onChangeConfirmPassword = this.onChangeConfirmPassword.bind(this);
    this._debounceTimer = null;
    this.dropdownRef = React.createRef();
    this.mapDivRef = React.createRef();
    this.gmapRef = null;
    this.gmarkerRef = null;
    this.geocodeTimerRef = null;
    this.state = {
      action: '',
      name: '',
      last_name: '',
      id_ambassador: 0,
      cellphone: '',
      country_code: '+51',
      email: '',
      nro_doc: '',
      data_ref: [],
      data_orders: [],
      data_orders_referidos: [],
      data_address: [],
      data_districts: [],
      open: false,
      open_history: false,
      message: '',
      address: '',
      url_address: '',
      ubigeo: '',
      number: '',
      interior: '',
      district: '',
      id_address: '',
      type_document: '',
      password: '',
      confirm_password: '',
      selectedDistrictOption: null,
      selectedTypeAddressOption: null,
      selectedTypeDocOption: null,
      selectedLeaveYourOrder: null,
      // Google Places
      searchQuery: '',
      suggestions: [],
      searchLoading: false,
      showDropdown: false,
      searchSubmitted: false,
      selected: null,
      // Map pin
      pinCoords: null,
      geocodedAddress: '',
      geocoding: false,
      mapsError: false,
      showManualUrl: false,
      errors: [
        {
          district: '',
        },
      ],
      dataTipoDireccion: [
        { value: 'AV', label: 'AV' },
        { value: 'CALLE', label: 'CALLE' },
        { value: 'JIRON', label: 'JIRÓN' },
      ],
      dataLeaveYourOrder: [
        { value: 'Conserje', label: 'Conserje' },
        { value: 'Cliente recoge', label: 'Cliente recoge' }
      ],
      dataTipo: [
        //{value: 'ADMIN',label: 'Administrador'},
        { value: 'DNI', label: 'DNI' },
        { value: 'PASAPORTE', label: 'Pasaporte' },
      ],
      dataEdit: 0,
    };
    this.validator = new SimpleReactValidator();
  }

  componentDidMount() {
    document.addEventListener('mousedown', this._handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this._handleClickOutside);
    clearTimeout(this.geocodeTimerRef);
  }

  _handleClickOutside = (e) => {
    if (this.dropdownRef.current && !this.dropdownRef.current.contains(e.target)) {
      this.setState({ showDropdown: false });
    }
  };

  componentWillMount() {
    var user = AuthService.getCurrentUser();
    if (user) {
      document.body.style = `background-color: #161616;font-family: 'Work Sans'`;
      this.checkOpen();
    } else {
      this.props.history.push('/login');
      window.location.reload();
    }
  }

  checkOpen() {
    var user = AuthService.getCurrentUser();
    ApiService.checkOpen(user.token).then(
      (res) => {
        if (res && res.status == 'success') {
          if (res.data.option_value == 'NO') {
            if (window.location.pathname != '/closed') {
              this.props.history.push('/closed');
            }
          } else {
            this.getUserData();
            this.getUserAddresses();
            this.getUserReferreds();
            this.getUserHistoryOrders();
            this.getUserHistoryOrdersReferidos();
            this.getDistricts();
          }
        } else {
          this.props.history.push('/closed');
          window.location.reload();
        }
      },
      (error) => {
        const resMessage =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
      }
    );
  }

  getUserData() {
    var user = AuthService.getCurrentUser();
    ApiService.getUserDetails(user.token, user.id).then(
      (res) => {
        if (res && res.status == 'success') {
          this.setState({ name: res.data.name ? res.data.name : '' });
          //this.setState({last_name: res.data.last_name?res.data.last_name:''});
          this.setState({
            id_ambassador: res.data.id_ambassador ? res.data.id_ambassador : 0,
          });
          this.setState({ email: res.data.email ? res.data.email : '' });
          this.setState({
            cellphone: res.data.Profile.cell_phonenumber
              ? res.data.Profile.cell_phonenumber
              : '',
            country_code: res.data.Profile.country_code
              ? res.data.Profile.country_code
              : '+51',
          });
          //this.setState({nro_doc: res.data.nro_document?res.data.nro_document:''});
          this.setState({
            type_document: res.data.type_document ? res.data.type_document : '',
          });
        }
      },
      (error) => {
        const resMessage =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
      }
    );
  }

  getDistricts() {
    var user = AuthService.getCurrentUser();
    ApiService.getDistricts(user.token).then(
      (res) => {
        if (res && res.status == 'success') {
          this.items = res.data.map(function(row) {
            return { value: row.id, label: row.name, key: row.id };
          });
          this.setState({ data_districts: this.items });
        }
      },
      (error) => {
        const resMessage =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
      }
    );
  }

  handleDistrict = (selectedDistrictOption) => {
    this.setState({ selectedDistrictOption });
  };

  handleTypeAddress = (selectedTypeAddressOption) => {
    const type = selectedTypeAddressOption ? selectedTypeAddressOption.value : '';
    const address = this.state.address;
    const number = this.state.number;
    const searchQuery = (type + ' ' + address + ' ' + number).trim();
    this.setState({ selectedTypeAddressOption, ...(this.state.selected ? {} : { searchQuery }) });
  };

  handleLeaveYourOrder = (selectedLeaveYourOrder) => {
    this.setState({ selectedLeaveYourOrder });
  };

  handleTypeDoc = (selectedTypeDocOption) => {
    this.setState({ selectedTypeDocOption });
  };

  onSearchChange = (e) => {
    this.setState({ searchQuery: e.target.value, selected: null, showDropdown: false, suggestions: [], searchSubmitted: false });
  };

  onSearchSubmit = async () => {
    const { searchQuery } = this.state;
    if (!searchQuery || searchQuery.trim().length < 3) return;
    this.setState({ searchLoading: true, showDropdown: false, suggestions: [], searchSubmitted: true });
    try {
      const user = AuthService.getCurrentUser();
      const suggestions = await ApiService.placesAutocomplete(user.token, searchQuery.trim());
      this.setState({ suggestions, showDropdown: suggestions.length > 0, searchLoading: false });
    } catch (err) {
      this.setState({ searchLoading: false });
    }
  };

  onSearchKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      this.onSearchSubmit();
    }
  };

  onSelectSuggestion = async (suggestion) => {
    this.setState({ showDropdown: false, searchQuery: suggestion.description, suggestions: [], searchLoading: true });
    try {
      const user = AuthService.getCurrentUser();
      const details = await ApiService.placeDetails(user.token, suggestion.place_id);
      this.setState({
        selected: details,
        searchLoading: false,
        address: details.formatted_address || suggestion.description,
      });
      if (details.latitude && details.longitude) {
        this.moveMapTo(parseFloat(details.latitude), parseFloat(details.longitude));
      }
    } catch (err) {
      this.setState({ searchLoading: false });
      Swal.fire({ icon: 'error', title: 'Error', text: 'No se pudo obtener la ubicación. Intenta de nuevo.', timer: 3000, showConfirmButton: false });
    }
  };

  handleUpdateUser(e) {
    e.preventDefault();

    this.setState({
      message: '',
      loading: true,
    });

    this.form.validateAll();

    if (!this.state.selectedTypeDocOption && this.state.dataEdit == 5) {
      this.setState({
        errors: { referred: 'Error' },
      });
      return true;
    } else {
      this.setState({
        errors: { referred: '' },
      });
    }

    if (
      this.checkBtn.context._errors.length === 0 &&
      !this.state.errors.referred
    ) {
      //this.setState({ open: false });
      var user = AuthService.getCurrentUser();
      let data_user = {
        name: this.state.name,
        //'last_name': this.state.last_name?this.state.last_name:'',
        email: this.state.email,
        cell_phonenumber: this.state.cellphone,
        country_code: this.state.country_code,
        id_ambassador: this.state.id_ambassador,
        //'nro_document': this.state.nro_doc?this.state.nro_doc:'',
        type_document: this.state.selectedTypeDocOption
          ? this.state.selectedTypeDocOption.value
          : '',
        id_user: user.id, //this.state.id_referred,
      };

      //return false;

      ApiService.updateUserData(user.token, data_user).then(
        (res) => {
          if (res) {
            if (res && res.status == 'success') {
              document.getElementById('update-user-overlay').style.display =
                'none';
              Swal.fire({
                icon: 'success',
                title: 'Hecho!',
                text:
                  'Los cambios se han solicitado al administrador. Se verán reflejados en máximo 24 horas.',
              });
              this.getUserData();
            } else {
            }
          }
        },
        (error) => {
          const resMessage =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();

          this.setState({
            loading: false,
            message: resMessage,
          });
        }
      );
    } else {
      this.setState({
        loading: false,
      });
    }
  }

  handleUpdatePassword(e) {
    e.preventDefault();

    this.setState({
      message: '',
      loading: true,
    });

    this.form.validateAll();

    if (
      !this.state.password ||
      this.state.password == '' ||
      !this.state.confirm_password ||
      this.state.confirm_password == ''
    ) {
      return true;
    }

    if (this.state.password != this.state.confirm_password) {
      return true;
    }

    if (this.checkBtn.context._errors.length === 0) {
      //this.setState({ open: false });
      var user = AuthService.getCurrentUser();
      let data_user = {
        password: this.state.password,
        //'id_user': user.id,//this.state.id_referred,
      };

      //return false;

      ApiService.updateUserPassword(user.token, data_user).then(
        (res) => {
          if (res) {
            if (res && res.status == 'success') {
              document.getElementById('update-password-overlay').style.display =
                'none';
              Swal.fire({
                icon: 'success',
                title: 'Hecho!',
                text: 'Contraseña actualizada.',
              });
              this.getUserData();
            } else {
            }
          }
        },
        (error) => {
          const resMessage =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();

          this.setState({
            loading: false,
            message: resMessage,
          });
        }
      );
    } else {
      this.setState({
        loading: false,
      });
    }
  }

  getUserAddresses() {
    var user = AuthService.getCurrentUser();
    ApiService.getUserAddresses(user.token, user.id).then(
      (res) => {
        if (res && res.status == 'success') {
          this.setState({ data_address: res.data });
        }
      },
      (error) => {
        const resMessage =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
      }
    );
  }

  getUserReferreds() {
    var user = AuthService.getCurrentUser();
    ApiService.getUserReferreds(user.token, user.id).then(
      (res) => {
        if (res && res.status == 'success') {
          this.setState({ data_ref: res.data });
        }
      },
      (error) => {
        const resMessage =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
      }
    );
  }

  getUserHistoryOrders() {
    var user = AuthService.getCurrentUser();
    ApiService.getUserHistoryOrders(user.token, user.id).then(
      (res) => {
        if (res && res.status == 'success') {
          for (let i = 0; i < res.data.length; i++) {
            res.data[i]['date'] = Moment(res.data[i]['date']).format(
              'DD-MM-YYYY'
            );
          }
          this.setState({ data_orders: res.data });
        }
      },
      (error) => {
        const resMessage =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
      }
    );
  }

  getUserHistoryOrdersReferidos() {
    var user = AuthService.getCurrentUser();
    ApiService.getUserHistoryOrdersReferidos(user.token, user.id).then(
      (res) => {
        if (res && res.status == 'success') {
          for (let i = 0; i < res.data.length; i++) {
            res.data[i]['date'] = Moment(res.data[i]['date']).format(
              'DD-MM-YYYY'
            );
          }
          this.setState({ data_orders_referidos: res.data });
        }
      },
      (error) => {
        const resMessage =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
      }
    );
  }

  handleUpdateAddress(e) {
    e.preventDefault();

    this.setState({
      message: '',
      loading: true,
    });

    this.form.validateAll();

    if (!this.state.selectedDistrictOption) {
      this.setState({
        errors: { district: 'Error' },
      });
      return true;
    } else {
      this.setState({
        errors: { district: '' },
      });
    }

    if (
      this.checkBtn.context._errors.length === 0 &&
      !this.state.errors.district
    ) {
      //this.setState({ open: false });
      //this.form.validateAll();
      var user = AuthService.getCurrentUser();
      const { selected, pinCoords } = this.state;
      const coordUrl = pinCoords ? 'https://www.google.com/maps/search/?api=1&query=' + pinCoords.lat + ',' + pinCoords.lng : '';
      let data_user = {
        id_address: this.state.id_address,
        type_address: this.state.selectedTypeAddressOption.value,
        leave_your_order: this.state.selectedLeaveYourOrder.value,
        address: this.state.address,
        number: this.state.number,
        interior: this.state.interior,
        url_google: selected ? selected.url_google : (this.state.url_address || coordUrl),
        ubigeo: this.state.selectedDistrictOption.value,
        district: this.state.selectedDistrictOption.label,
        id_user: user.id,
        latitude: selected ? selected.latitude : (pinCoords ? pinCoords.lat : null),
        longitude: selected ? selected.longitude : (pinCoords ? pinCoords.lng : null),
      };

      ApiService.updateAddressData(user.token, data_user).then(
        (res) => {
          if (res) {
            if (res && res.status == 'success') {
              document.getElementById('add-address-overlay').style.display =
                'none';
              Swal.fire({
                icon: 'success',
                title: 'Hecho!',
                text:
                  'Los cambios se han solicitado al administrador. Se verán reflejados en máximo 24 horas.',
              });
              this.getUserAddresses();
            } else {
            }
          }
        },
        (error) => {
          const resMessage =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();

          this.setState({
            loading: false,
            message: resMessage,
          });
        }
      );
    } else {
      this.setState({
        loading: false,
      });
    }
  }

  handleAddAddress(e) {
    e.preventDefault();

    this.setState({
      message: '',
      loading: true,
    });

    this.form.validateAll();

    if (!this.state.selectedDistrictOption) {
      this.setState({
        errors: { district: 'Error' },
      });
      return true;
    } else {
      this.setState({
        errors: { district: '' },
      });
    }

    if (
      this.checkBtn.context._errors.length === 0 &&
      !this.state.errors.district
    ) {

      var user = AuthService.getCurrentUser();

      const { selected, pinCoords } = this.state;
      const coordUrl = pinCoords ? 'https://www.google.com/maps/search/?api=1&query=' + pinCoords.lat + ',' + pinCoords.lng : '';
      let data_user = {
        type_address: this.state.selectedTypeAddressOption.value,
        leave_your_order: this.state.selectedLeaveYourOrder.value,
        address: this.state.address,
        number: this.state.number,
        interior: this.state.interior,
        url_google: selected ? selected.url_google : (this.state.url_address || coordUrl),
        ubigeo: this.state.selectedDistrictOption.value,
        district: this.state.selectedDistrictOption.label,
        id_user: user.id,
        latitude: selected ? selected.latitude : (pinCoords ? pinCoords.lat : null),
        longitude: selected ? selected.longitude : (pinCoords ? pinCoords.lng : null),
      };


      ApiService.addAddressData(user.token, data_user).then(
        (res) => {
          if (res) {
            if (res && res.status == 'success') {
              document.getElementById('add-address-overlay').style.display =
                'none';
              Swal.fire({
                icon: 'success',
                title: 'Hecho!',
                text:
                  'Los cambios se han solicitado al administrador. Se verán reflejados en máximo 24 horas.',
              });
              this.getUserAddresses();
            
            } else {
            }
          }
        },
        (error) => {
          const resMessage =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();

          this.setState({
            loading: false,
            message: resMessage,
          });
        }
      );
    } else {
      this.setState({
        loading: false,
      });
    }
  }

  onChangeAddress(e) {
    const address = e.target.value;
    const type = this.state.selectedTypeAddressOption ? this.state.selectedTypeAddressOption.value : '';
    const number = this.state.number;
    const searchQuery = (type + ' ' + address + ' ' + number).trim();
    this.setState({ address, ...(this.state.selected ? {} : { searchQuery }) });
  }

  /*onChangeUbigeo(e) {
        this.setState({
            ubigeo: e.target.value
        });
      }*/

  onChangeNumber(e) {
    const number = e.target.value;
    const type = this.state.selectedTypeAddressOption ? this.state.selectedTypeAddressOption.value : '';
    const address = this.state.address;
    const searchQuery = (type + ' ' + address + ' ' + number).trim();
    this.setState({ number, ...(this.state.selected ? {} : { searchQuery }) });
  }

  onChangeInterior(e) {
    this.setState({
      interior: e.target.value,
    });
  }

  onChangeUrl(e) {
    this.setState({ url_address: e.target.value, selected: null });
  }

  onChangeReference(e) {
    this.setState({
      reference: e.target.value,
    });
  }
  onchangeName(e) {
    this.setState({
      name: e.target.value,
    });
  }
  onchangeLastName(e) {
    this.setState({
      last_name: e.target.value,
    });
  }
  onchangeEmail(e) {
    this.setState({
      email: e.target.value,
    });
  }
  onChangePassword(e) {
    this.setState({
      password: e.target.value,
    });
  }
  onChangeConfirmPassword(e) {
    this.setState({
      confirm_password: e.target.value,
    });
  }

  onChangeCellphone(e) {
    let val = e.target.value;
    let max = 15;
    let vale_lenght = val.toString().length;

    if (vale_lenght <= max) {
      this.setState({
        cellphone: e.target.value,
      });
    } else {
      this.setState({
        cellphone: this.state.cellphone,
      });
    }
  }

  onChangeCountryCode(e) {
    this.setState({ country_code: e.target.value });
  }

  onChangeNroDoc(e) {
    this.setState({
      nro_doc: e.target.value,
    });
  }

 
  removeAddress = (item) => {
    var user = AuthService.getCurrentUser();
    
    Swal.fire({
      title: 'Confirmar',
      text: '¿Desea elminar la dirección ' + item.address + '?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Confirmar',
      cancelButtonText: 'Cancelar',
    }).then((result) => {
      if (result.value) {
        var user = AuthService.getCurrentUser();
        ApiService.deletetUserAddress(user.token, user.id, item.id).then(
          (res) => {
            if (res && res.status == 'success') {
              Swal.fire({
                icon: 'success',
                title: 'Hecho!',
                text: 'Dirección Eliminada!',
              });
              this.getUserAddresses();
            }
          },
          (error) => {
            const resMessage =
              (error.response &&
                error.response.data &&
                error.response.data.message) ||
              error.message ||
              error.toString();
          }
        );
      }
    });
  
  };

  initMap() {
    if (!this.mapDivRef.current) return;
    if (!window.google || !window.google.maps) { this.setState({ mapsError: true }); return; }
    if (this.gmapRef) return;
    try {
      this.gmapRef = new window.google.maps.Map(this.mapDivRef.current, {
        center: LIMA, zoom: 12,
        mapTypeControl: false, streetViewControl: false, fullscreenControl: false, zoomControl: true,
      });
      this.gmarkerRef = new window.google.maps.Marker({ map: this.gmapRef, draggable: true, visible: false });
      this.gmarkerRef.addListener('dragend', () => {
        var p = this.gmarkerRef.getPosition();
        var lat = p.lat(), lng = p.lng();
        var coordUrl = 'https://www.google.com/maps/search/?api=1&query=' + lat + ',' + lng;
        this.setState({ pinCoords: { lat: lat, lng: lng }, selected: null, url_address: coordUrl, searchSubmitted: false, showDropdown: false });
        this.triggerReverseGeocode(lat, lng);
      });
      this.gmapRef.addListener('click', (e) => {
        var lat = e.latLng.lat(), lng = e.latLng.lng();
        var coordUrl = 'https://www.google.com/maps/search/?api=1&query=' + lat + ',' + lng;
        this.gmarkerRef.setPosition(e.latLng);
        this.gmarkerRef.setVisible(true);
        this.setState({ pinCoords: { lat: lat, lng: lng }, selected: null, url_address: coordUrl, searchSubmitted: false, showDropdown: false });
        this.triggerReverseGeocode(lat, lng);
      });
    } catch (e) { this.setState({ mapsError: true }); }
  }

  moveMapTo(lat, lng) {
    if (!this.gmapRef || !this.gmarkerRef) return;
    var pos = { lat: lat, lng: lng };
    this.gmapRef.setCenter(pos);
    this.gmapRef.setZoom(17);
    this.gmarkerRef.setPosition(pos);
    this.gmarkerRef.setVisible(true);
    this.setState({ pinCoords: pos });
    this.triggerReverseGeocode(lat, lng);
  }

  // Posiciona el pin sin disparar reverse geocode (para precargar edición)
  placePinAt(lat, lng) {
    if (!this.gmapRef || !this.gmarkerRef) return;
    var pos = { lat: lat, lng: lng };
    this.gmapRef.setCenter(pos);
    this.gmapRef.setZoom(17);
    this.gmarkerRef.setPosition(pos);
    this.gmarkerRef.setVisible(true);
  }

  resetMapToLima() {
    if (!this.gmapRef || !this.gmarkerRef) return;
    this.gmapRef.setCenter(LIMA);
    this.gmapRef.setZoom(12);
    this.gmarkerRef.setVisible(false);
    this.setState({ pinCoords: null, geocodedAddress: '' });
  }

  parseRouteType(route) {
    var prefixes = [
      { patterns: ['avenida ', 'av. ', 'av '], type: 'AV' },
      { patterns: ['calle ', 'ca. ', 'ca '], type: 'CALLE' },
      { patterns: ['jirón ', 'jiron ', 'jr. ', 'jr '], type: 'JIRON' },
    ];
    var lower = (route || '').toLowerCase();
    for (var i = 0; i < prefixes.length; i++) {
      for (var j = 0; j < prefixes[i].patterns.length; j++) {
        if (lower.startsWith(prefixes[i].patterns[j])) {
          return { type: prefixes[i].type, name: route.substring(prefixes[i].patterns[j].length).trim() };
        }
      }
    }
    return { type: null, name: route || '' };
  }

  triggerReverseGeocode(lat, lng) {
    clearTimeout(this.geocodeTimerRef);
    this.geocodeTimerRef = setTimeout(async () => {
      this.setState({ geocoding: true });
      try {
        var user = AuthService.getCurrentUser();
        var data = await ApiService.reverseGeocode(user.token, lat, lng);
        if (!data) return;

        var parsed = this.parseRouteType(data.route);
        var newState = {
          geocodedAddress: data.formatted_address || '',
          address: parsed.name,
          number: data.street_number || '',
          searchQuery: data.formatted_address || '',
        };

        if (parsed.type) {
          var typeMatch = this.state.dataTipoDireccion.find(function(d) { return d.value === parsed.type; });
          if (typeMatch) newState.selectedTypeAddressOption = typeMatch;
        }

        if (data.district) {
          var norm = function(s) {
            return s.toLowerCase()
              .normalize('NFD').replace(/[̀-ͯ]/g, '')
              .trim();
          };
          var districtNorm = norm(data.district);
          var districtMatch =
            this.state.data_districts.find(function(d) { return norm(d.label) === districtNorm; }) ||
            this.state.data_districts.find(function(d) { return norm(d.label).includes(districtNorm) || districtNorm.includes(norm(d.label)); });
          if (districtMatch) newState.selectedDistrictOption = districtMatch;
        }

        this.setState(newState);
      } catch (e) {
        // silencioso
      } finally {
        this.setState({ geocoding: false });
      }
    }, 600);
  }

  editAddress = (item) => {
    var districtOption  = this.state.data_districts.find(function(d) { return d.value === item.ubigeo; }) || null;
    var typeOption      = this.state.dataTipoDireccion.find(function(d) { return d.value === item.type_address; }) || null;
    var leaveOption     = this.state.dataLeaveYourOrder.find(function(d) { return d.value === item.leave_your_order; }) || null;
    var initPin         = (item.latitude && item.longitude)
                          ? { lat: parseFloat(item.latitude), lng: parseFloat(item.longitude) }
                          : null;
    var searchQ         = [item.type_address, item.address, item.number].filter(Boolean).join(' ').trim();

    this.setState({
      id_address: item.id || '',
      address: item.address || '',
      number: item.number || '',
      interior: item.interior || '',
      url_address: item.url_google || '',
      ubigeo: item.ubigeo || '',
      searchQuery: searchQ,
      suggestions: [], showDropdown: false, searchSubmitted: false,
      selected: null,
      pinCoords: initPin,
      geocodedAddress: '', geocoding: false, mapsError: false, showManualUrl: false,
      selectedDistrictOption: districtOption,
      selectedTypeAddressOption: typeOption,
      selectedLeaveYourOrder: leaveOption,
      action: 'update',
    });

    document.getElementById('add-address-overlay').style.display = 'block';

    setTimeout(() => {
      this.initMap();
      if (initPin) {
        this.placePinAt(initPin.lat, initPin.lng);
      } else {
        this.resetMapToLima();
      }
    }, 50);
  };

  registerAddress = (e) => {
    this.setState({
      id_address: '', address: '', url_address: '', number: '', interior: '',
      ubigeo: '', district: '', selectedDistrictOption: null,
      selectedTypeAddressOption: null, selectedLeaveYourOrder: null,
      searchQuery: '', suggestions: [], showDropdown: false, searchSubmitted: false, selected: null,
      pinCoords: null, geocodedAddress: '', mapsError: false, showManualUrl: false,
      action: 'register',
    });
    document.getElementById('add-address-overlay').style.display = 'block';
    setTimeout(() => {
      this.initMap();
      this.resetMapToLima();
    }, 50);
  };

  editUser = (item) => {
    this.setState({ dataEdit: item });
    var user = AuthService.getCurrentUser();
    for (let i = 0; i < this.state.dataTipo.length; i++) {
      if (this.state.dataTipo[i]['value'] === this.state.type_document) {
        this.handleTypeDoc(this.state.dataTipo[i]);
      }
    }
    document.getElementById('update-user-overlay').style.display = 'block';
  
  };

  onCloseModal = () => {
    this.setState({ open: false });
  };

 
  onOpenModalHistoryReferidos() {
    document.getElementById('history-overlay-referidos').style.display = 'block';
  }

  onCloseModalHistoryReferidos() {
    document.getElementById('history-overlay-referidos').style.display = 'none';
  }
  onOpenModalHistory() {
    document.getElementById('history-overlay').style.display = 'block';
  }

  onCloseModalHistory() {
    document.getElementById('history-overlay').style.display = 'none';
  }

  onCloseModalAddAddress() {
    document.getElementById('add-address-overlay').style.display = 'none';
  }

  onCloseModalUpdateUser() {
    document.getElementById('update-user-overlay').style.display = 'none';
  }

  onOpenModalUpdatePassword() {
    document.getElementById('update-password-overlay').style.display = 'block';
  }

  onCloseModalPassword() {
    document.getElementById('update-password-overlay').style.display = 'none';
  }

  removeReferred = (item) => {
    var user = AuthService.getCurrentUser();
    Swal.fire({
      title: 'Confirmar',
      text: '¿Desea elminar el referdio ' + item.name + '?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Confirmar',
      cancelButtonText: 'Cancelar',
    }).then((result) => {
      if (result.value) {
        var user = AuthService.getCurrentUser();
        /*let data = {
                    'id_user': data_row.original.id,
                    'status_confirm': status,
                }*/
        /*ApiService.postStateUser(user.token,data).then(
                    (res) => {
                        if(res && res.status == 'success'){
                            if(status==1)
                            {
                                Swal.fire("Hecho!", "Usuario Aprobado!", "success");
                            }else{
                                Swal.fire("Hecho!", "Usuario Rechazado!", "success");
                            }
                            //toast.success("Orden Aceptada!");
                            this.setState({results: []});
                            this.getDataUser();
                        }
                    },
                    error => {
                      const resMessage =
                        (error.response &&
                          error.response.data &&
                          error.response.data.message) ||
                        error.message ||
                        error.toString();
                    }
                  );*/
      }
    });
    /*ApiService.deleteCartUser(user.token,item.id).then(
            (res) => {
                if(res && res.status == 'success'){
                    this.getUserAddresses();
                }
            },
            error => {
              const resMessage =
                (error.response &&
                  error.response.data &&
                  error.response.data.message) ||
                error.message ||
                error.toString();
            }
          );*/
  };

  render() {
    const { cartItems, symbol, total } = this.props;
    const { selectedDistrictOption } = this.state;
    const { selectedTypeAddressOption } = this.state;
    const { selectedTypeDocOption } = this.state;
    const { selectedLeaveYourOrder } = this.state;

    document.body.classList.add('dark');

    const customStyles = {
      option: (styles, { data, isDisabled, isFocused, isSelected }) => {
        // const color = chroma(data.color);
        return {
          ...styles,
          backgroundColor: isFocused ? '#161616' : '#161616',
          color: isFocused ? '#F8EEE1' : '#F8EEE1',
        };
      },
      placeholder: (defaultStyles) => {
        return {
          ...defaultStyles,
          position: 'absolute',
          display: 'inherit',
          paddingLeft: '2px',
        };
      },
      control: (base, state) => ({
        ...base,
        background: '#161616',
        //opacity: 0.5,
        border: '2px solid #F8EEE1',
        //color: "#cfd4da",
        borderRadius: 30,
        backgroundColor: state.isFocused ? '#161616' : null,
      }),
      singleValue: (base, state) => ({
        ...base,
        color: '#F8EEE1',
        position: 'absolute',
        display: 'inherit',
        paddingLeft: '2px',
      }),
      input: (base, state) => ({
        ...base,
        position: 'absolute',
        color: '#F8EEE1',
      }),
      valueContainer: (base, state) => ({
        ...base,
        minHeight: 'inherit',
      }),
    };

    return (
      <div
        className="cart-container"
        style={{ backgroundColor: '#161616 !important' }}
      >
        <div className="breadcrumb-section title-cart profile-tittle">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="page-title page-tittle2">
                  {/*<h1>{title}</h1>*/}
                  <label className="text-confirm-order">MI PERFIL</label>
                </div>
              </div>
            </div>
          </div>
        </div>

        <section className="section-b-space" style={{ paddingTop: '0px' }}>
          <div className="container padding-cls">
            <div className="checkout-page container-profile">
              <div className="checkout-form profile-content">
                <div
                  className="checkout row container-data-profile"
                  style={{ margin: 'auto' }}
                >
                  <div className="col-lg-12 col-sm-12 col-xs-12">
                    <div className="profile-data">
                      {/*<div className="referred-checkout-title">
                                                    <label>Datos del referido</label>
                                                </div>*/}
                      <div className="row check-out row-check-date">
                        <div className="form-group col-md-6 col-sm-6 col-xs-12 profile-input">
                          <div className="field-label ver-label">
                            <img
                              src={`${process.env.PUBLIC_URL}/assets/images/icon/ver-user.png`}
                              alt=""
                              className="img-fluid"
                            />{' '}
                            Nombres:
                          </div>
                          <input
                            type="text"
                            name="name"
                            value={this.state.name}
                            readOnly
                          />
                          {this.state.id_ambassador == 0 ? (
                            <span
                              className="fa fa-pencil btn-edit-profile"
                              onClick={() => this.editUser(1)}
                            ></span>
                          ) : (
                            ''
                          )}
                        </div>

                        <div
                          className="form-group col-md-6 col-sm-6 col-xs-12 profile-input"
                          style={{ marginBottom: '10px' }}
                        >
                          <div className="field-label ver-label">
                            <img
                              src={`${process.env.PUBLIC_URL}/assets/images/icon/mail.png`}
                              alt=""
                              className="img-fluid"
                            />{' '}
                            Mail:
                          </div>
                          <input
                            type="text"
                            name="email"
                            value={this.state.email}
                            readOnly
                          />
                          {this.state.id_ambassador == 0 ? (
                            <span
                              className="fa fa-pencil btn-edit-profile"
                              onClick={() => this.editUser(3)}
                            ></span>
                          ) : (
                            ''
                          )}
                        </div>
                      </div>
                      <div className="row check-out row-check-date">
                        <div className="form-group col-md-6 col-sm-6 col-xs-12 profile-input">
                          <div className="field-label ver-label">
                            <img
                              src={`${process.env.PUBLIC_URL}/assets/images/icon/ver-phone.png`}
                              alt=""
                              className="img-fluid"
                            />{' '}
                            Número de cel:
                          </div>
                          <input
                            type="text"
                            name="cellphone"
                            value={`${this.state.country_code} ${this.state.cellphone}`}
                            readOnly
                          />
                          {this.state.id_ambassador == 0 ? (
                            <span
                              className="fa fa-pencil btn-edit-profile"
                              onClick={() => this.editUser(4)}
                            ></span>
                          ) : (
                            ''
                          )}
                        </div>
                      </div>
                      {(AuthService.getCurrentUser() &&
                        AuthService.getCurrentUser().role == 'EMBAJADOR') ||
                      (AuthService.getCurrentUser() &&
                        AuthService.getCurrentUser().role == 'CLIENTE') ? (
                        <div className="row check-out row-check-date">
                          <div
                            className="form-group col-md-6 col-sm-6 col-xs-12 profile-input"
                            style={{ margin: '0 auto' }}
                          >
                            <div className="field-label ver-label">
                              <img
                                src={`${process.env.PUBLIC_URL}/assets/images/icon/ver-address.png`}
                                alt=""
                                className="img-fluid"
                              />{' '}
                              Mis direcciones:
                            </div>
                            <div className="profile-address">
                              {this.state.data_address.map((item, index) => {
                                return (
                                  <div key={index}>
                                    <a
                                      className="icon"
                                      onClick={() => this.editAddress(item)}
                                    >
                                      {item.type_address} {item.address}{' '}
                                      {item.number}
                                    </a>
                                    <span className="btn-edit-address">
                                      <a
                                        style={{ marginLeft: '20px' }}
                                        className="icon"
                                        onClick={() => this.removeAddress(item)}
                                      >
                                        <i className="fa fa-times"></i>
                                      </a>
                                    </span>
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        </div>
                      ) : (
                        ''
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {(AuthService.getCurrentUser() &&
              AuthService.getCurrentUser().role == 'EMBAJADOR') ||
            (AuthService.getCurrentUser() &&
              AuthService.getCurrentUser().role == 'CLIENTE') ? (
              <div>
                <div
                  className="row check-out row-check-date"
                  style={{ textAlign: 'center', marginTop: '1.5rem' }}
                >
                  {AuthService.getCurrentUser() &&
                  AuthService.getCurrentUser().role == 'EMBAJADOR' ? (
                  <div className="form-group col-md-12 col-sm-6 col-xs-12 profile-buttons bnt-ver-profile">
                    <Link
                      to={`${process.env.PUBLIC_URL}/referreds`}
                      className="btn-solid btn btn-edit-reffered btn-primary"
                    >
                    
                      EDITAR REFERIDOS{' '}
                      <img
                        src={`${process.env.PUBLIC_URL}/assets/images/icon/ver-reffered.png`}
                        alt=""
                        className="img-fluid"
                        style={{ marginLeft: '5px' }}
                      />
                    </Link>
                  </div>
                
                    
                    
                  ) : (
                    ''
                  )}

                {AuthService.getCurrentUser() &&
                  AuthService.getCurrentUser().role == 'EMBAJADOR' ? (
                    <div className="form-group col-md-12 col-sm-6 col-xs-12 profile-buttons bnt-ver-profile">
                    <a
                      role="button" style={{cursor:'pointer'}}
                      onClick={this.onOpenModalHistoryReferidos}
                      className="ver-btn-solid btn btn-order-history btn-primary"
                    >
                      PEDIDOS REFERIDOS
                    </a>
                  </div>
                
                    
                    
                  ) : (
                    ''
                  )}      
                  <div className="form-group col-md-12 col-sm-6 col-xs-12 profile-buttons bnt-ver-profile">
                    <a
                      role="button" style={{cursor:'pointer'}}
                      onClick={this.onOpenModalUpdatePassword}
                      className="ver-btn-solid btn btn-order-history btn-primary"
                    >
                      {/*{this.state.loading && (
                                            <span className="spinner-border spinner-border-sm"></span>
                                        )}*/}
                      CAMBIAR CONTRASEÑA
                    </a>
                  </div>
                  <div className="form-group col-md-12 col-sm-6 col-xs-12 profile-buttons bnt-ver-profile">
                    <a
                      role="button" style={{cursor:'pointer'}}
                      onClick={this.onOpenModalHistory}
                      className="ver-btn-solid btn btn-order-history btn-primary"
                    >
                      HISTORIAL DE PEDIDOS
                    </a>
                  </div>
                  <div className="form-group col-md-12 col-sm-6 col-xs-12 profile-buttons bnt-ver-profile">
                    <a
                      role="button" style={{cursor:'pointer'}}
                      onClick={() => this.registerAddress()}
                      className="ver-btn-solid btn btn-save-address btn-primary"
                    >
                      {/*{this.state.loading && (
                                            <span className="spinner-border spinner-border-sm"></span>
                                        )}*/}
                      AGREGAR DIRECCION
                    </a>
                  </div>
                </div>
              </div>
            ) : (
              ''
            )}
            {AuthService.getCurrentUser() &&
            AuthService.getCurrentUser().role == 'REFERIDO' ? (
              <>
                <div
                  className="row check-out row-check-date"
                  style={{ textAlign: 'center', marginTop: '1.5rem' }}
                >
                  <div className="form-group col-md-12 col-sm-6 col-xs-12 profile-buttons bnt-ver-profile">
                    <a
                      role="button" style={{cursor:'pointer'}}
                      onClick={this.onOpenModalUpdatePassword}
                      className="ver-btn-solid btn btn-order-history btn-primary"
                    >

                      CAMBIAR CONTRASEÑA
                    </a>
                  </div>
                </div>
                <div className="ref-order-history">
                  <div className="row">
                    <label className="text-order-history">
                      HISTORIAL DE PEDIDOS
                    </label>
                  </div>
                  <div className="row">
                    <div className="container padding-cls">
                      <div className="checkout-page">
                        <div className="checkout-form register-address-form">
                          <div
                            className="checkout row container-data-profile"
                            style={{ margin: 'auto' }}
                          >
                            <div className="col-lg-12 col-sm-12 col-xs-12">
                              <div className="row">
                                {this.state.data_orders.map((item, index) => {
                                  return (
                                    <Collapsible
                                      triggerStyle={{ color: '#12DB6F' }}
                                      key={index}
                                      trigger={
                                        <div style={{ display: 'flex' }}>
                                          <span>
                                            <i
                                              className="fa fa-circle"
                                              aria-hidden="true"
                                            ></i>
                                            PEDIDO. #{item.id}
                                          </span>
                                          <span
                                            style={{
                                              position: 'absolute',
                                              right: '40px',
                                            }}
                                          >
                                            {item.date}
                                          </span>
                                        </div>
                                      }
                                    >
                                      <div className="order-history-details">
                                        <div>
                                          {item.Purchases_detail.map(
                                            (sub_item, subindex) => (
                                              <p
                                                key={`sub_item_name` + subindex}
                                              >
                                               ({sub_item.quantity}) {sub_item.Product.name}
                                              </p>
                                            )
                                          )}
                                        </div>
                                        <div>
                                          <p>Delivery :
                                          {' '}
                                          {item.delivery? parseFloat(item.delivery).toFixed(2) : 0}
                                          </p> 
                                          <p>SubTotal :
                                          {' '}
                                          {parseFloat(item.total).toFixed(2)}
                                          </p>
                                          <p>Total</p>
                                          <p>
                                            <img
                                              src={`${process.env.PUBLIC_URL}/assets/images/icon/credit.png`}
                                              alt=""
                                              className="img-fluid"
                                              style={{
                                                position: 'relative',
                                                bottom: '2px',
                                              }}
                                            />{' '}
                                            {calculateTotal(parseFloat(item.total).toFixed(2), parseFloat(item.delivery).toFixed(2))}
                                          </p>
                                        </div>
                                      </div>
                                    </Collapsible>
                                  );
                                })}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            ) : (
              ''
            )}
          </div>
        </section>

        <div id="history-overlay" className="search-overlay history-overlay">
          <div>
            <span
              className="closebtn"
              onClick={this.onCloseModalHistory}
              title="Close Overlay"
            >
              ×
            </span>
            <div
              className="overlay-content modal-profile-overlay-content"
              style={{ position: 'absolute', top: '5.5rem' }}
            >
              <div className="container">
                <div className="row" style={{ marginBottom: '2rem' }}>
                  <div className="col-md-12">
                    <div className="page-title title-modal-profile">
                      {/*<h1>{title}</h1>*/}
                      <label className="text-confirm-order">
                        HISTORIAL DE PEDIDOS
                      </label>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="container padding-cls">
                    <div className="checkout-page">
                      <div className="checkout-form register-address-form">
                        <div
                          className="checkout row container-data-profile"
                          style={{ margin: 'auto' }}
                        >
                          <div className="col-lg-12 col-sm-12 col-xs-12">
                            <div className="row">
                              {this.state.data_orders.map((item, index) => {
                                return (
                                  <Collapsible
                                    triggerStyle={{ color: '#12DB6F' }}
                                    key={index}
                                    trigger={
                                      <div style={{ display: 'flex' }}>
                                        <span>
                                          <i
                                            className="fa fa-circle"
                                            aria-hidden="true"
                                          ></i>
                                          PEDIDO #{item.id}
                                        </span>
                                        <span
                                          style={{
                                            position: 'absolute',
                                            right: '40px',
                                          }}
                                        >
                                          {item.date}
                                        </span>
                                      </div>
                                    }
                                  >
                                    <div className="order-history-details">
                                      <div>
                                        {item.Purchases_detail.map(
                                          (sub_item, subindex) => (
                                            <p key={`sub_item_name` + subindex}>
                                              ({sub_item.quantity}) {sub_item.Product.name}
                                            </p>
                                          )
                                        )}
                                      </div>
                                      <div>
                                      <p>Delivery :
                                      {' '}
                                      {item.delivery? parseFloat(item.delivery).toFixed(2) : 0}
                                      </p> 
                                      <p>SubTotal :
                                      {' '}
                                      {parseFloat(item.total).toFixed(2)}
                                      </p>
                                      <p>Total <br />
                                      <img
                                        src={`${process.env.PUBLIC_URL}/assets/images/icon/credit.png`}
                                        alt=""
                                        className="img-fluid"
                                        style={{
                                          position: 'relative',
                                          bottom: '2px',
                                        }}
                                      />{' '}
                                      {calculateTotal(parseFloat(item.total).toFixed(2), parseFloat(item.delivery).toFixed(2))}
                                      </p>
                                      </div>
                                    </div>
                                  </Collapsible>
                                );
                              })}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div id="history-overlay-referidos" className="search-overlay history-overlay">
          <div>
            <span
              className="closebtn"
              onClick={this.onCloseModalHistoryReferidos}
              title="Close Overlay"
            >
              ×
            </span>
            <div
              className="overlay-content modal-profile-overlay-content"
              style={{ position: 'absolute', top: '5.5rem' }}
            >
              <div className="container">
                <div className="row" style={{ marginBottom: '2rem' }}>
                  <div className="col-md-12">
                    <div className="page-title title-modal-profile">
                      {/*<h1>{title}</h1>*/}
                      <label className="text-confirm-order">
                        PEDIDOS DE REFERIDOS
                      </label>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="container padding-cls">
                    <div className="checkout-page">
                      <div className="checkout-form register-address-form">
                        <div
                          className="checkout row container-data-profile"
                          style={{ margin: 'auto' }}
                        >
                          <div className="col-lg-12 col-sm-12 col-xs-12">
                            <div className="row">
                              {this.state.data_orders_referidos.map((item, index) => {
                                return (
                                  <Collapsible
                                    triggerStyle={{ color: '#12DB6F' }}
                                    key={index}
                                    trigger={
                                      <div style={{ display: 'flex' }}>
                                        <span>
                                          <i
                                            className="fa fa-circle"
                                            aria-hidden="true"
                                          ></i>
                                          PEDIDO #{item.id_order} - {item.User.name}
                                        </span>
                                        <span
                                          style={{
                                            position: 'absolute',
                                            right: '40px',
                                          }}
                                        >
                                          {item.date}
                                        </span>
                                      </div>
                                    }
                                  >
                                    <div className="order-history-details">
                                      <div>
                                        {item.Purchases_detail.map(
                                          (sub_item, subindex) => (
                                            <p key={`sub_item_name` + subindex}>
                                              ({sub_item.quantity}) {sub_item.Product.name}
                                            </p>
                                          )
                                        )}
                                      </div>
                                      <div>
                                        <p>Total</p>
                                        <p>
                                          <img
                                            src={`${process.env.PUBLIC_URL}/assets/images/icon/credit.png`}
                                            alt=""
                                            className="img-fluid"
                                            style={{
                                              position: 'relative',
                                              bottom: '2px',
                                            }}
                                          />{' '}
                                          {parseFloat(item.total).toFixed(2)}
                                        </p>
                                      </div>
                                    </div>
                                  </Collapsible>
                                );
                              })}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          id="add-address-overlay"
          className="ver-modal-overlay add-address-overlay"
          style={{ overflow: 'auto' }}
        >
          <div>
            <span
              className="closebtn"
              onClick={this.onCloseModalAddAddress}
              title="Close Overlay"
            >
              ×
            </span>
            <div
              className="overlay-content"
              style={{ position: 'absolute', top: '5.5rem' }}
            >
              <div
                className="container"
                style={{ padding: '0px 30px 0px 20px' }}
              >
                <div className="row" style={{ marginBottom: '2rem' }}>
                  <div className="col-md-12">
                    <div className="page-title title-modal-profile">
                      {/*<h1>{title}</h1>*/}
                      <label className="text-confirm-order">
                        {this.state.action == 'register'
                          ? 'REGISTRAR DIRECCIÓN'
                          : 'ACTUALIZAR DIRECCIÓN'}
                      </label>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="container padding-cls">
                    <div className="checkout-page">
                      <div className="checkout-form register-address-form">
                        <div
                          className="checkout row container-data-address"
                          style={{ margin: 'auto' }}
                        >
                          <div className="col-lg-12 col-sm-12 col-xs-12">
                            <div className="row">
                              <Form
                                style={{ width: '100%' }}
                                //onSubmit={this.handleAddAddress}
                                onSubmit={
                                  this.state.action == 'register'
                                    ? this.handleAddAddress
                                    : this.handleUpdateAddress
                                }
                                autoComplete="off"
                                encType="multipart/form-data"
                                method="POST"
                                ref={(c) => {
                                  this.form = c;
                                }}
                              >
                                
                                <Input type="text" name="id_address" value={this.state.id_address} hidden="1" />

                                {/* 1. BUSCAR EN GOOGLE */}
                                <div className="row check-out row-check-date" style={{ marginBottom: '0.5rem' }}>
                                  <div className="form-group col-md-12 col-sm-6 col-xs-12" ref={this.dropdownRef} style={{ position: 'relative' }}>
                                    <div className="field-label">BUSCAR DIRECCIÓN EN GOOGLE</div>
                                    <div style={{ display: 'flex', gap: 8 }}>
                                      <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Ej: Ca. Los Pinos 156, Miraflores"
                                        value={this.state.searchQuery}
                                        onChange={this.onSearchChange}
                                        onKeyDown={this.onSearchKeyDown}
                                        autoComplete="off"
                                        style={{ background: '#161616', color: '#F8EEE1', border: '2px solid #F8EEE1', borderRadius: 30, padding: '6px 14px', flex: 1 }}
                                      />
                                      <button
                                        type="button"
                                        onClick={this.onSearchSubmit}
                                        disabled={this.state.searchLoading || this.state.searchQuery.trim().length < 3}
                                        style={{ background: '#12DB6F', color: '#161616', border: 'none', borderRadius: 30, padding: '6px 16px', fontWeight: 600, cursor: 'pointer', whiteSpace: 'nowrap' }}
                                      >
                                        {this.state.searchLoading ? '⏳' : 'Buscar'}
                                      </button>
                                    </div>
                                    <small style={{ color: '#888', fontSize: 11 }}>Escribe la dirección y presiona Buscar o Enter.</small>
                                    {this.state.showDropdown && this.state.suggestions.length > 0 && (
                                      <ul style={{ listStyle: 'none', margin: 0, padding: 0, border: '1px solid #444', borderRadius: 4, background: '#222', position: 'absolute', zIndex: 999, width: '100%', maxHeight: 200, overflowY: 'auto' }}>
                                        {this.state.suggestions.map((s) => (
                                          <li key={s.place_id} style={{ padding: '8px 12px', cursor: 'pointer', fontSize: 13, color: '#F8EEE1', borderBottom: '1px solid #333' }} onMouseDown={() => this.onSelectSuggestion(s)}>
                                            📍 {s.description}
                                          </li>
                                        ))}
                                      </ul>
                                    )}
                                    {this.state.searchSubmitted && !this.state.searchLoading && this.state.suggestions.length === 0 && !this.state.selected && (
                                      <small style={{ color: '#e57373', display: 'block', marginTop: 4 }}>No se encontraron resultados. Intenta con otra descripción o toca el mapa.</small>
                                    )}
                                    {this.state.selected && (
                                      <div style={{ marginTop: 8, padding: '10px 12px', background: '#0d3b1e', border: '1px solid #12DB6F', borderRadius: 8, color: '#F8EEE1', fontSize: 13 }}>
                                        <div style={{ fontWeight: 600, marginBottom: 2 }}>Ubicación seleccionada</div>
                                        <div style={{ color: '#ccc', marginBottom: 4 }}>{this.state.selected.formatted_address}</div>
                                        <a href={this.state.selected.url_google} target="_blank" rel="noopener noreferrer" style={{ color: '#12DB6F', fontSize: 12 }}>Ver en mapa ↗</a>
                                      </div>
                                    )}
                                  </div>
                                </div>

                                {/* 2. MAPA */}
                                <div style={{ marginBottom: '1.5rem' }}>
                                  <div style={{ fontSize: 11, fontWeight: 600, letterSpacing: '0.05em', color: '#aaa', marginBottom: 8, textTransform: 'uppercase' }}>
                                    UBICACIÓN EN EL MAPA
                                  </div>
                                  <div style={{ position: 'relative', borderRadius: 12, overflow: 'hidden', border: '2px solid #2a2a2a', background: '#1a1a1a', minHeight: 260 }}>
                                    <div ref={this.mapDivRef} style={{ width: '100%', height: 260, display: 'block' }} />
                                    {!this.state.pinCoords && !this.state.mapsError && (
                                      <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 12, background: '#1e1e1e', color: '#666', fontSize: 13, textAlign: 'center', padding: 20, zIndex: 1 }}>
                                        <span style={{ fontSize: 40, opacity: 0.35 }}>🗺️</span>
                                        <span>Busca tu dirección arriba o toca el mapa para marcar tu ubicación</span>
                                      </div>
                                    )}
                                    {this.state.mapsError && (
                                      <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 12, background: '#1e1e1e', color: '#666', fontSize: 13, textAlign: 'center', padding: 20, zIndex: 1 }}>
                                        <span style={{ fontSize: 40, opacity: 0.35 }}>⚠️</span>
                                        <span>No se pudo cargar Google Maps. Usa el link abajo.</span>
                                      </div>
                                    )}
                                  </div>
                                  {this.state.pinCoords && (
                                    <div style={{ padding: '7px 14px', fontSize: 11, color: '#888', textAlign: 'center', background: '#1a1a1a', borderTop: '1px solid #2a2a2a' }}>
                                      {this.state.geocoding ? '⌛ Buscando dirección...' : '📌 Arrastra el pin o toca el mapa para ajustar la ubicación'}
                                    </div>
                                  )}
                                </div>

                                {/* 3. AV / CALLE / JIRON */}
                                <div className="row check-out" style={{ marginBottom: '1rem' }}>
                                  <div className="form-group col-md-4 col-sm-4 col-xs-12" style={{ maxWidth: '100%', flex: 'auto' }}>
                                    <div className="field-label" style={{ marginBottom: '10px' }}>AV/ CALLE/ JIRÓN</div>
                                    <Select
                                      value={selectedTypeAddressOption}
                                      onChange={this.handleTypeAddress}
                                      options={this.state.dataTipoDireccion}
                                      placeholder={'Seleccione una opción'}
                                      styles={customStyles}
                                    />
                                    {this.state.errors.typeAddress && !this.state.selectedTypeAddressOption && (
                                      <div className="alert alert-danger ver-alert" role="alert">Este campo es obligatorio!</div>
                                    )}
                                  </div>
                                </div>

                                {/* 4. NOMBRE */}
                                <div className="row check-out row-check-date" style={{ marginBottom: '1rem' }}>
                                  <div className="form-group col-md-12 col-sm-6 col-xs-12">
                                    <div className="field-label">NOMBRE</div>
                                    <Input type="text" name="address" value={this.state.address} onChange={this.onChangeAddress} validations={[required]} />
                                  </div>
                                </div>

                                {/* 5. NÚMERO */}
                                <div className="row check-out row-check-date" style={{ marginBottom: '1rem' }}>
                                  <div className="form-group col-md-12 col-sm-6 col-xs-12">
                                    <div className="field-label">NÚMERO</div>
                                    <Input type="text" name="number" value={this.state.number} onChange={this.onChangeNumber} validations={[required]} />
                                  </div>
                                </div>

                                {/* 6. INTERIOR */}
                                <div className="row check-out row-check-date" style={{ marginBottom: '1rem' }}>
                                  <div className="form-group col-md-12 col-sm-6 col-xs-12">
                                    <div className="field-label">INTERIOR <span style={{ color: '#666', fontWeight: 400, fontSize: 11 }}>(opcional)</span></div>
                                    <Input type="text" name="interior" value={this.state.interior} onChange={this.onChangeInterior} placeholder="Dpto, piso, oficina..." />
                                  </div>
                                </div>

                                {/* 7. DISTRITO */}
                                <div className="row check-out" style={{ marginBottom: '1rem' }}>
                                  <div className="form-group col-md-4 col-sm-4 col-xs-12" style={{ maxWidth: '100%', flex: 'auto' }}>
                                    <div className="field-label" style={{ marginBottom: '10px' }}>DISTRITO</div>
                                    <Select
                                      value={selectedDistrictOption}
                                      onChange={this.handleDistrict}
                                      options={this.state.data_districts}
                                      placeholder={'Seleccione un distrito'}
                                      styles={customStyles}
                                    />
                                    {this.state.errors.district && !this.state.selectedDistrictOption && (
                                      <div className="alert alert-danger ver-alert" role="alert">Este campo es obligatorio!</div>
                                    )}
                                  </div>
                                </div>

                                {/* 8. CON QUIÉN */}
                                <div className="row check-out" style={{ marginBottom: '1rem' }}>
                                  <div className="form-group col-md-4 col-sm-4 col-xs-12" style={{ maxWidth: '100%', flex: 'auto' }}>
                                    <div className="field-label" style={{ marginBottom: '10px' }}>¿Con quién dejamos tu pedido?</div>
                                    <Select
                                      value={selectedLeaveYourOrder}
                                      onChange={this.handleLeaveYourOrder}
                                      options={this.state.dataLeaveYourOrder}
                                      placeholder={'Seleccione una opción'}
                                      styles={customStyles}
                                    />
                                    {this.state.errors.typeAddress && !this.state.selectedLeaveYourOrder && (
                                      <div className="alert alert-danger ver-alert" role="alert">Este campo es obligatorio!</div>
                                    )}
                                  </div>
                                </div>

                                {/* 9. LINK GOOGLE MAPS */}
                                <div className="row check-out row-check-date" style={{ marginBottom: '1.5rem' }}>
                                  <div className="form-group col-md-12 col-sm-6 col-xs-12">
                                    <div className="field-label" style={{ marginBottom: '6px' }}>
                                      LINK DE GOOGLE MAPS
                                      <span style={{ color: '#666', fontWeight: 400, fontSize: 11, marginLeft: 6 }}>(se llena automático con el mapa)</span>
                                    </div>
                                    <Input
                                      type="text"
                                      name="url_address"
                                      value={this.state.selected ? this.state.selected.url_google : this.state.url_address}
                                      onChange={this.onChangeUrl}
                                      validations={[required]}
                                      placeholder="https://maps.google.com/..."
                                    />
                                  </div>
                                </div>

                                <div
                                  className="row check-out row-check-date"
                                  style={{
                                    textAlign: 'center',
                                    marginTop: '1rem',
                                  }}
                                >
                                  <div className="form-group col-md-12 col-sm-6 col-xs-12">
                                    <button className="ver-btn-solid btn btn-save-address btn-primary">
                                    
                                      GUARDAR
                                    </button>
                                  </div>
                                </div>
                                {this.state.message && (
                                  <div className="form-group">
                                    <div
                                      className="alert alert-danger"
                                      role="alert"
                                    >
                                      {this.state.message}
                                    </div>
                                  </div>
                                )}
                                <CheckButton
                                  style={{ display: 'none' }}
                                  ref={(c) => {
                                    this.checkBtn = c;
                                  }}
                                />
                              </Form>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          id="update-user-overlay"
          className="ver-modal-overlay update-user-overlay"
          style={{ overflow: 'auto' }}
        >
          <div>
            <span
              className="closebtn"
              onClick={this.onCloseModalUpdateUser}
              title="Close Overlay"
            >
              ×
            </span>
            <div
              className="overlay-content"
              style={{ position: 'absolute', top: '5.5rem' }}
            >
              <div
                className="container"
                style={{ padding: '0px 30px 0px 20px' }}
              >
                <div className="row" style={{ marginBottom: '2rem' }}>
                  <div className="col-md-12">
                    <div className="page-title title-modal-profile">
                      <label className="text-confirm-order">
                        ACTUALIZAR DATOS
                      </label>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="container padding-cls">
                    <div className="checkout-page">
                      <div className="checkout-form register-address-form">
                        <div
                          className="checkout row container-data-address"
                          style={{ margin: 'auto' }}
                        >
                          <div className="col-lg-12 col-sm-12 col-xs-12">
                            <div className="row">
                              <Form
                                style={{ width: '100%' }}
                                onSubmit={this.handleUpdateUser}
                                autoComplete="off"
                                encType="multipart/form-data"
                                method="POST"
                                ref={(c) => {
                                  this.form = c;
                                }}
                              >
                                {this.state.dataEdit == 1 ? (
                                  <div
                                    className="row check-out row-check-date"
                                    style={{ marginBottom: '1rem' }}
                                  >
                                    <Input
                                      type="text"
                                      name="id_referred"
                                      value={this.state.id_referred}
                                      hidden="1"
                                    />
                                    <div className="form-group col-md-12 col-sm-6 col-xs-12">
                                      <div className="field-label">NOMBRES</div>
                                      <Input
                                        type="text"
                                        name="address"
                                        value={this.state.name}
                                        onChange={this.onchangeName}
                                        validations={[required]}
                                      />
                                    </div>
                                  </div>
                                ) : (
                                  ''
                                )}
                                {/*this.state.dataEdit==2?
                                    <div className="row check-out row-check-date" style={{marginBottom: '1rem'}}>
                                        <Input type="text" name="id_referred" value={this.state.id_referred} hidden="1"/>
                                        <div className="form-group col-md-12 col-sm-6 col-xs-12">
                                            <div className="field-label">APELLIDOS</div>
                                            <Input type="text" name="address" value={this.state.last_name} onChange={this.onchangeLastName} validations={[required]}/>
                                        </div>
                                    </div>
                                    :''
                                */}
                                {this.state.dataEdit == 3 ? (
                                  <div
                                    className="row check-out row-check-date"
                                    style={{ marginBottom: '1rem' }}
                                  >
                                    <div className="form-group col-md-12 col-sm-6 col-xs-12">
                                      <div className="field-label">MAIL</div>
                                      <Input
                                        type="text"
                                        name="address"
                                        value={this.state.email}
                                        onChange={this.onchangeEmail}
                                        validations={[required]}
                                      />
                                    </div>
                                  </div>
                                ) : (
                                  ''
                                )}
                                {this.state.dataEdit == 4 ? (
                                  <div
                                    className="row check-out row-check-date"
                                    style={{ marginBottom: '1rem' }}
                                  >
                                    <div className="form-group col-md-12 col-sm-6 col-xs-12">
                                      <div className="field-label">CELULAR</div>
                                      <div className="phone-input-group">
                                        <select
                                          value={this.state.country_code}
                                          onChange={(e) => this.onChangeCountryCode(e)}
                                          className="input-country-code"
                                        >
                                          {COUNTRY_CODES.map(c => (
                                            <option key={c.code} value={c.code}>
                                              {c.code} {c.name}
                                            </option>
                                          ))}
                                        </select>
                                        <Input
                                          type="number"
                                          name="address"
                                          value={this.state.cellphone}
                                          onChange={(e) =>
                                            this.onChangeCellphone(e)
                                          }
                                          validations={[required]}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                ) : (
                                  ''
                                )}
                                {this.state.dataEdit == 5 ? (
                                  <div
                                    className="row check-out"
                                    style={{ marginBottom: '1rem' }}
                                  >
                                    <div
                                      className="form-group col-md-4 col-sm-4 col-xs-12"
                                      style={{ maxWidth: '100%', flex: 'auto' }}
                                    >
                                      <div
                                        className="field-label"
                                        style={{ marginBottom: '10px' }}
                                      >
                                        TIPO DE DOCUMENTO
                                      </div>
                                      <Select
                                        value={selectedTypeDocOption}
                                        onChange={this.handleTypeDoc}
                                        options={this.state.dataTipo}
                                        placeholder={
                                          'Seleccione un tipo de documento'
                                        }
                                        styles={customStyles}
                                      />
                                      {this.state.errors.referred &&
                                      !this.state.selectedTypeDocOption ? (
                                        <div
                                          className="alert alert-danger ver-alert"
                                          role="alert"
                                        >
                                          Este campo es obligatorio!
                                        </div>
                                      ) : (
                                        ''
                                      )}
                                    </div>
                                  </div>
                                ) : (
                                  ''
                                )}
                                
                                <div
                                  className="row check-out row-check-date"
                                  style={{
                                    textAlign: 'center',
                                    marginTop: '2rem',
                                  }}
                                >
                                  <div className="form-group col-md-12 col-sm-6 col-xs-12">
                                    <button className="ver-btn-solid btn btn-save-address btn-primary">
                                      GUARDAR
                                    </button>
                                  </div>
                                </div>
                                {this.state.message && (
                                  <div className="form-group">
                                    <div
                                      className="alert alert-danger"
                                      role="alert"
                                    >
                                      {this.state.message}
                                    </div>
                                  </div>
                                )}
                                <CheckButton
                                  style={{ display: 'none' }}
                                  ref={(c) => {
                                    this.checkBtn = c;
                                  }}
                                />
                              </Form>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          id="update-password-overlay"
          className="ver-modal-overlay update-password-overlay"
          style={{ overflow: 'auto' }}
        >
          <div>
            <span
              className="closebtn"
              onClick={this.onCloseModalPassword}
              title="Close Overlay"
            >
              ×
            </span>
            <div
              className="overlay-content"
              style={{ position: 'absolute', top: '5.5rem' }}
            >
              <div
                className="container"
                style={{ padding: '0px 30px 0px 20px' }}
              >
                <div className="row" style={{ marginBottom: '2rem' }}>
                  <div className="col-md-12">
                    <div className="page-title title-modal-profile">
                      <label className="text-confirm-order">
                        CAMBIAR CONTRASEÑA
                      </label>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="container padding-cls">
                    <div className="checkout-page">
                      <div className="checkout-form register-address-form">
                        <div
                          className="checkout row container-data-address"
                          style={{ margin: 'auto' }}
                        >
                          <div className="col-lg-12 col-sm-12 col-xs-12">
                            <div className="row">
                              <Form
                                style={{ width: '100%' }}
                                onSubmit={this.handleUpdatePassword}
                                autoComplete="off"
                                encType="multipart/form-data"
                                method="POST"
                                ref={(c) => {
                                  this.form = c;
                                }}
                              >
                                <div
                                  className="row check-out row-check-date"
                                  style={{ marginBottom: '1rem' }}
                                >
                                  <div className="form-group col-md-12 col-sm-6 col-xs-12">
                                    <div className="field-label">
                                      CONTRASEÑA
                                    </div>
                                    <Input
                                      type="password"
                                      name="address"
                                      value={this.state.password}
                                      onChange={this.onChangePassword}
                                    />
                                    {!this.state.password ||
                                    this.state.password == '' ? (
                                      <div
                                        className="alert alert-danger ver-alert"
                                        role="alert"
                                      >
                                        Este campo es obligatorio!
                                      </div>
                                    ) : (
                                      ''
                                    )}
                                  </div>
                                </div>

                                <div
                                  className="row check-out row-check-date"
                                  style={{ marginBottom: '1rem' }}
                                >
                                  <div className="form-group col-md-12 col-sm-6 col-xs-12">
                                    <div className="field-label">
                                      CONFIRMAR CONTRASEÑA
                                    </div>
                                    <Input
                                      type="password"
                                      name="address"
                                      value={this.state.confirm_password}
                                      onChange={this.onChangeConfirmPassword}
                                    />
                                    {!this.state.confirm_password ||
                                    this.state.confirm_password == '' ? (
                                      <div
                                        className="alert alert-danger ver-alert"
                                        role="alert"
                                      >
                                        Este campo es obligatorio!
                                      </div>
                                    ) : (
                                      ''
                                    )}
                                    {this.state.password &&
                                    this.state.confirm_password &&
                                    this.state.password !=
                                      this.state.confirm_password ? (
                                      <div
                                        className="alert alert-danger ver-alert"
                                        role="alert"
                                      >
                                        La contraseña no coincide
                                      </div>
                                    ) : (
                                      ''
                                    )}
                                  </div>
                                </div>

                                <div
                                  className="row check-out row-check-date"
                                  style={{
                                    textAlign: 'center',
                                    marginTop: '2rem',
                                  }}
                                >
                                  <div className="form-group col-md-12 col-sm-6 col-xs-12">
                                    <button className="ver-btn-solid btn btn-save-address btn-primary">
                                      GUARDAR
                                    </button>
                                  </div>
                                </div>
                                {this.state.message && (
                                  <div className="form-group">
                                    <div
                                      className="alert alert-danger"
                                      role="alert"
                                    >
                                      {this.state.message}
                                    </div>
                                  </div>
                                )}
                                <CheckButton
                                  style={{ display: 'none' }}
                                  ref={(c) => {
                                    this.checkBtn = c;
                                  }}
                                />
                              </Form>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  cartItems: state.cartList.cart,
  symbol: state.data.symbol,
  total: getCartTotal(state.cartList.cart),
});

export default connect(mapStateToProps, { removeFromWishlist })(VerProfile);
